// Module
var code = "<div class=\"row map-nav\"> <div class=\"col-sm-2\">&nbsp;</div> <div class=\"col-sm-10\"> <ar-search-nav-toolbar/> <div class=\"btn-group\" ar-map-translocations-button></div> </div> </div> ";
// Exports
module.exports = code;